import { ReactNode } from 'react';

import { Loader } from 'elements/loader';

import './Button.scss';

enum ButtonSize {
  sm = 'sm',
  lg = 'lg',
}

enum ButtonColor {
  gray = 'gray',
  blue = 'blue',
  gradient = 'gradient',
}

type Props = {
  children: ReactNode;
  clickHandler: Function;
  isLoading?: boolean;
  isDisabled?: boolean;
  size?: keyof typeof ButtonSize;
  color?: keyof typeof ButtonColor;
};

const Button = ({ children, size, color, clickHandler, isLoading, isDisabled }: Props) => {
  return (
    <button
      className={`button ${size ? size : ''} ${color ? color : ''}`}
      onClick={() => clickHandler()}
      disabled={isDisabled || isLoading}
    >
      {isLoading && <Loader />}
      {children}
    </button>
  );
};

export default Button;
